import React from 'react';

function Main() {
    return (
        <div />
    );
}

export default Main;
